import { gql } from '@apollo/client';

export const DEBOUNCE_TIME = 700;

export const GET_ALL_TESTERS = gql`
  query Users($limit: Int!, $offset: Int!, $order: String!, $search: String,
    $guest: Boolean, $status: String, $lastLoginMonths: Int) {
    users(limit: $limit, offset: $offset, order: $order,
      tester: true, search: $search, guest: $guest, status: $status, lastLoginMonths: $lastLoginMonths) {
      id
      createdAt
      guest
      profile {
        id
        firstName
        lastName
        linkedinFields {
          emailAddress
          educationLevel
          linkedinUrl
          pictureUrl
          currentPosition {
            title
            description
            seniority
            company {
              name
              size
              industry
            }
            startDate {
              year
              month
            }
            endDate {
              year
              month
            }
          }
        }
        email
        birthdate
        gender
        raceEthnicHeritage
        workStatus
        annualHouseholdIncome
        webExpertise
        browsers
        smartphone
        tablet
        otherDevices
        country
        state
        zipcode
        recruitingProgram
        jobCategories {
          name
        }
        paymentMethod
        paypalAccount
        venmoAccount
        currentPosition {
          title
          seniority
          company {
            size
            industry
          }
        }
      }
    }
    usersCount(tester: true, guest: $guest, status: $status, lastLoginMonths: $lastLoginMonths)
  }
`;
